module.exports = __webpack_public_path__ + "static/media/collaboration.3f299bfa.svg";